import { initializeBaloiseDesignSystem } from "./initialize";
export default function () {
    initializeBaloiseDesignSystem();
}
